import { lazy } from 'react';

const PrivacyPolicyPage = lazy(() => import('../pages/PrivacyPolicy.page'));

const PrivacyPolicyRoutes = [
    {
        path: '/privacy-policy',
        element: <PrivacyPolicyPage />,
        layout: 'default',
        isAuthReq: false,
    },
];

export { PrivacyPolicyRoutes };

